
<template>
  <!-- start page title -->
  <div class="row">
    <b-breadcrumb
      :items="items"
      class="ml-2 mb-0 pb-1"
    ></b-breadcrumb>
    <div class="col-12">
      <div class="page-title-box">
        <span class="page-title font-weight-bold">{{ title }}</span>
        <br v-if="subtitle !== ''">
        <span v-if="subtitle !== ''" class="display-5">{{ subtitle }}</span>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
}
</script>
